import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\GetCateringSupplierOrderByDossierController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetCateringSupplierOrderByDossierController.php
* @route '/api/catering-order-by-dossier/{dossier}'
*/
const GetCateringSupplierOrderByDossierController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCateringSupplierOrderByDossierController.url(args, options),
    method: 'get',
})

GetCateringSupplierOrderByDossierController.definition = {
    methods: ["get","head"],
    url: '/api/catering-order-by-dossier/{dossier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SupplierOrder\GetCateringSupplierOrderByDossierController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetCateringSupplierOrderByDossierController.php
* @route '/api/catering-order-by-dossier/{dossier}'
*/
GetCateringSupplierOrderByDossierController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetCateringSupplierOrderByDossierController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\GetCateringSupplierOrderByDossierController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetCateringSupplierOrderByDossierController.php
* @route '/api/catering-order-by-dossier/{dossier}'
*/
GetCateringSupplierOrderByDossierController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCateringSupplierOrderByDossierController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SupplierOrder\GetCateringSupplierOrderByDossierController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetCateringSupplierOrderByDossierController.php
* @route '/api/catering-order-by-dossier/{dossier}'
*/
GetCateringSupplierOrderByDossierController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCateringSupplierOrderByDossierController.url(args, options),
    method: 'head',
})

export default GetCateringSupplierOrderByDossierController